import React, { useMemo } from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import { StreamingUgcNumbers } from 'fym-shared/src/music24/streamingSections';
import { TypedMemo } from '../../../../common/types';
import { DeltaPill } from '../../../components/primitives/DeltaPill';
import { Panel } from '../../../components/primitives/Panel';
import { UGC_NUMBER_KEYS } from '../../periodSections';
import { changePctOf, formatChangePct, formatCompact } from '../../streamingFormat';
import { shortVideoMessages as messages } from '../../shortVideoMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import shared from '../../Streaming.module.scss';
/* eslint-enable css-modules/no-unused-class */
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the period sections; each part uses its own slice of it */
import styles from '../../StreamingPeriod.module.scss';
/* eslint-enable css-modules/no-unused-class */

export const UGC_NUMBER_LABELS: Record<keyof StreamingUgcNumbers, MessageDescriptor> = {
  creations: messages.creations,
  views: messages.views,
  likes: messages.likes,
  shares: messages.shares,
  comments: messages.comments,
  favourites: messages.favourites,
};

interface UgcTilesProps {
  totals: StreamingUgcNumbers;
  previous: StreamingUgcNumbers | null;
}

/** The six tiles of Short video (design streaming-sections c1): flows of the period, with the change. */
const UgcTilesComponent: React.FC<UgcTilesProps> = ({ totals, previous }) => {
  const intl = useIntl();
  const tiles = useMemo(
    () =>
      UGC_NUMBER_KEYS.map((key) => {
        const changePct = changePctOf(totals[key], previous?.[key] ?? null);
        const change = formatChangePct(intl, changePct);
        const label = intl.formatMessage(UGC_NUMBER_LABELS[key]);
        return (
          <Panel key={key} className={shared.tile} role="group" aria-label={label}>
            <span className={shared.tileLabel}>{label}</span>
            <span className={shared.tileValue}>{formatCompact(intl, totals[key])}</span>
            {change !== null && changePct !== null ? (
              <span className={shared.tileRow}>
                <DeltaPill value={changePct} label={change} />
              </span>
            ) : null}
          </Panel>
        );
      }),
    [intl, previous, totals]
  );
  return (
    <div className={styles.kpis} data-testid="streaming-shortVideo-tiles">
      {tiles}
    </div>
  );
};

export const UgcTiles = TypedMemo(UgcTilesComponent);
